<template>
  <div class="body1">
    <div style="font-size: 35px;font-weight: bold;text-align: center">中小企业信用服务信息查询</div>
    <div><a href="../../../static/creditSearchAll.html">aaa</a></div>
    <div><a href="../../../static/zzcx.html">bbb</a></div>
    <div class="div1">
      <el-form ref="formInline" :inline="true" :model="formInline" :rules="rules" class="demo-form-inline">
        <el-form-item style="margin-left: -140px !important;"  prop="searchname">
          <el-input v-model="formInline.searchname" placeholder="请输入企业名称或统一社会信用代码" style="width: 700px"></el-input>
        </el-form-item>
        <el-form-item style="margin-left: 580px;margin-top: -63px;">
          <el-button type="primary" @click="checkForm('formInline')"   @keyup.enter.native="checkForm('formInline')">公示查询</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="searchjg">
       <div  class="gradeX"  v-for="(item,index) in tableData" :key="index">
                            <div class="ename" >公司名称:{{item.eName}}</div>
                            <div class="ecode">

                            <td class="ecode1">公司信用代码:{{item.eCode}}</td>
                            <td class="ecode1">有效期:{{item.term}}</td>
                            <td class="ecode1">
                              <router-link :to="{path:'/creditdetails',query:{pid:item.id}}"  class="sidebar-nav-link" >
        <el-button type="text" size="small">查看详情</el-button>
          </router-link></td>

                            </div>
       </div>
    </div>
    <div class="div2">
      <p><strong>提示：</strong><br>1、本网站为企业提供第三方评价机构对企业信用评价和认证结果查询服务，评价和认证结果一般在企业申报政策、参与 招投标项目或其他商业活动中使用。公示企业可免费查询。目前仅公示合作第三方信用服务机构的的企业信用信息,尚未覆盖所有企业信用数据。<br><br>
2、查询结果不代表本网站对查询对象信用状况的评估。所有数据均由第三方信用机构提供，企业评级或认证标准级操作 流程均由第三方信用服务机构自行提供及负责。<br><br>
3、如对网站信用数据建设有进一步建议或意见，欢迎拨打本网站电话：010-68575152。</p>
    </div>

    </div>
</template>

<script>
import rootPathssb from '@/api/mainApi'
import { dataPost } from '@/api/index'
export default {
  name: 'creditsearch',
  data () {
    return {
      rules: {
        searchname: [
          { required: true, message: '请输入搜索条件', trigger: 'blur' }
        ]

      },
      showHeader: false,
      formInline: {
        searchname: ''
      },
      tableData: [],
      pid: ''
    }
  },
  methods: {
    submitForm (event) {
      let that = this
      let param = new URLSearchParams()
      param.append('serchname', that.formInline.searchname)
      dataPost(rootPathssb.rootPath + '/public/find', param).then(function (response) {
        that.tableData = response.data.info
        // eslint-disable-next-line handle-callback-err
      }).catch(function (error) {
        that.$message({
          message: '无结果，请输入有效企业名称或信用代码',
          type: 'warning'
        })
      })
    },
    checkForm (formName) {
      let that = this
      this.$refs[formName].validate((valid) => {
        if (valid) {
          that.submitForm()
          console.log('成功!')
        } else {
          console.log('提交失败')
          return false
        }
      })
    }
  }
}
</script>

<style >
.div1{
    padding-top: 100px;
    padding-bottom: 10px ;
    width:800px;
    margin:auto;

}
  .div2{
    padding: 10px;
   margin: 0 auto;
    width: 700px;
    height: 250px;
    background-color: #ffffff;
    color:#888888;
    line-height: 24px;
    font-size: 14px;
    font-family: 微软雅黑;

  }
  .searchjg{
    width: 800px;
    margin: auto;
    margin-bottom: 100px;
  }
  .ename{
    font-size: 28px;
    line-height: 35px;
    color: #ff1111;
    margin-bottom: 10px;
  }
  .ecode{
    font-size: 14px;
    color: #888888;
    border-bottom: 1px #999999 solid;
    margin-bottom: 10px;
    line-height: 30px;
  }
  .ecode1{
    padding-right: 80px;

  }
.body1  .el-form-item__label{
  width: 140px !important;
}
.body1 .el-form-item__content{
   margin-left: 140px !important;
 }
</style>



// WEBPACK FOOTER //
// src/components/computer/creditsearch.vue